import type { IData } from '../model/IData'

export function getParentCouple(data: IData, personId: string) {
	return Object.values(data.couplesById).find((it) =>
		it.childIds?.includes(personId),
	)
}
